import * as customQueries from "@/customGraphql/queires";
import { API, graphqlOperation } from "aws-amplify";
import dayjs from "dayjs";
import { IAllSaleStatRepository } from "./allSaleStat.type";
// import * as queries from "@/graphql/queries";

export class AllSaleStatAPIRepository implements IAllSaleStatRepository {
    async getAllSaleStat(
        granularity: any,
        timestamp: any,
        nextToken?: string
    ): Promise<any> {
        const result = (await API.graphql({
            ...graphqlOperation(
                customQueries.saleStatByGranularityWithTimestamp,
                {
                    granularity,
                    timestamp,
                    nextToken,
                }
            ),
            ...{
                authMode: "AMAZON_COGNITO_USER_POOLS",
            },
        })) as any;
        return result.data.saleStatByGranularityWithTimestamp;
    }
    async refreshDailyStat(): Promise<void> {
        const result = await API.post("saletoolapi", "/stat/daily", {
            body: {
                date: dayjs().format("YYYY-MM-DD"),
            },
        });
        console.log({ result });
        return;
    }
}
